import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, effect } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom, Subscription } from 'rxjs';
import { ChatGptService } from 'src/app/services/chat-gpt.service';
import { ChatStateService } from 'src/app/services/chat-state.service';
import { FileValidationService } from 'src/app/services/file-validation.service';
import { LoaderService } from 'src/app/services/loader.service';
import { OneUIService } from 'src/app/services/one-ui.service';
import { RouterService } from 'src/app/services/router.service';
import { ToastMessageService } from 'src/app/services/toast-message.service';
import { VoiceRecognitionService } from 'src/app/services/voice-recognition.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-chat-textarea',
  templateUrl: './chat-textarea.component.html',
  styleUrls: ['./chat-textarea.component.scss']
})
export class ChatTextareaComponent implements OnInit, OnChanges, OnDestroy {
  isInputFocused: boolean = false;
  dropDownValue: 'azure' | 'google' = 'azure'
  sub!: Subscription;
  uploadSub!: Subscription;
  subSpeech!: Subscription;
  subFeature!: Subscription;
  subLoading!: Subscription;

  newFiles: any = [];
  activeFeature: any = 'chatGPT';
  @ViewChild('textarea') textarea!: ElementRef;
  prompt: string = '';
  fileProgress: { [key: string]: number } = {};
  uploadingFiles: string[] = [];
  cursorPosition: number = 0;

  selectedFiles: any[] = [];
  @Output() filename = new EventEmitter<any>();
  @Output() fileuploaded = new EventEmitter<any>();
  inputAccept = '.pdf,.PDF,.txt,.TXT,.pptx,.PPTX,.ppt,.pptx,.doc,.DOC,.docx,.DOCX,.xlsx,.XLXS,.csv,.CSV,.xls,.XLS,.jpeg,.png,.jpg,.PNG,.tif,.tiff,.mp3,.mp4,.m4a,.m4v,.wav';
  inputGcpChatAccept = '.pdf,.docx,.png,.jpg,.jpeg,.csv,.xlsx,.ppt,.pptx';
  inputDatalabsAccept = '.xlsx,.XLXS,.csv,.CSV,.xls,.XLS';
  translateImageAccept = '.png, .jpeg, .jpg, .PNG, .tif,.tiff';
  translateinputAccept = '.pdf,.PDF,.txt,.TXT,.pptx,.PPTX,.ppt,.pptx,.doc,.DOC,.docx,.DOCX,.xlsx,.XLXS,.csv,.CSV,.xls,.XLS,.jpeg,.png,.jpg,.PNG,.tif,.tiff';

  uploadFileCategory: any = [
    { title: 'Summarize', name: 'byod', max: '.pdf, .txt, .pptx, .docx, .xlsx,.jpg, .png, .jpeg files allowed. max 16MB allowed', value: ['pdf', 'PDF', 'txt', 'TXT', 'pptx', 'PPTX', 'pptx', 'docx', 'DOCX', 'xlsx', 'XLXS', 'csv', 'CSV', 'xls', 'XLS', 'jpeg', 'png', 'jpg'] },
    { title: 'Translate', name: 'translate', max: '.pdf, .txt, .pptx, .docx, .xlsx,.jpg, .png, .jpeg and .tiff files allowed max 16MB allowed', value: ['txt', 'xlsx', 'xls', 'pdf', 'PDF', 'pptx', 'PPTX', 'ppt', 'pptx', 'doc', 'DOC', 'docx', 'DOCX', 'png', 'jpeg', 'jpg', 'PNG', 'tif', 'tiff'] },
    { title: 'Transcribe', name: 'transcribe', max: '.mp3, .mp4, .m4a, .m4v, .wav files allowed max 50MB allowed', value: ['mp3', 'mp4', 'm4a', 'm4v', 'wav'] }
  ]


  intervalId: any;
  loading = false;
  uploadProgress = false;
  uploadStatus = false;
  myRouterSub!: Subscription;
  currentRoute: any;

  subChatConfig!: Subscription;
  chatConfig: any;
  gcpFilePaylaod: any;

@ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @Input() promptImageStatus!: boolean;
  imageUpload = false;
  deploymentEnv = environment?.deployment;
  constructor(
    private chatStateService: ChatStateService,
    private chatGptService: ChatGptService,
    private router: Router,
    private toastMessage: ToastMessageService,
    private loaderService: LoaderService,
    private voiceService: VoiceRecognitionService,
    private fileValidationService: FileValidationService,
    private oneUIService: OneUIService,
    private routerService: RouterService,


  ) {

    effect(() => {
      if (this.chatStateService.uploadFileSignal()) {
        this.uploadFile();
      }
    });

    this.checkDatalabsRoute();

    this.sub = this.loaderService.loading.subscribe((res: any) => {
      this.loading = res;
    })

    this.uploadSub = this.loaderService.progress.subscribe((res: any) => {
      this.uploadProgress = res;
    })

    this.subChatConfig = this.chatStateService.chatConfigState.subscribe((res: any) => {
      if (res) {
        if (this.chatConfig?.chat_model != 'gcp') this.gcpFilePaylaod = null;
        this.chatConfig = res;
        if (res?.chat_model == 'gcp') this.chatConfig["top_p"] = 1;
      } else {
        this.chatConfig = {
          "top_p": 0.85, "temperature": 0.7, "model": "gpt4", "max_tokens": 4000, "chat_style": false, "style_guide": true, "chat_model": 'azure'
        }
      }
    });

    // this.clearUserRecord();

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['promptImageStatus']) {
      console.log('Checkbox value changed:', changes['promptImageStatus'].currentValue);
    }
  }

  
  ngOnInit(): void {
    // if (this.currentRoute === 'translate') {
    if (this.gptModelSwitchBlock()) {
      const storedValue = localStorage.getItem('translate_model');
      if (storedValue === 'azure' || storedValue === 'google') {
        this.dropDownValue = storedValue;
      } else {
        this.dropDownValue = 'azure';
      }

      this.chatStateService.chatModelState.next(this.dropDownValue);
      this.chatModelSwitch(this.dropDownValue);
    }else{
      this.dropDownValue = 'azure';
      this.chatStateService.chatModelState.next(this.dropDownValue);
      this.chatModelSwitch(this.dropDownValue);
    }

    this.clearUserRecord();

    this.subFeature = this.chatStateService.featureState.subscribe((res: any) => {
      this.activeFeature = res;
    })

    this.subSpeech = this.voiceService.speechResult.subscribe((text: any) => {
      if (text) {
        this.voiceService.insertTextAtCursor(text, this.textarea);
        this.prompt = this.textarea.nativeElement.value;
      }
      this.stopVoiceRecognition();
    });

    this.sub = this.chatStateService.promptInputState.subscribe((res: any) => {
      this.prompt = res;
    })

    this.chatGptService.stopStreaming();
  }

  setTranslate(): void {
    console.log(this.dropDownValue);

  }

  // get router and manage file upload condition 
  checkDatalabsRoute(): void {
    this.myRouterSub = this.routerService.currentRoute.subscribe((res: any) => {
      const activeRoute = res.url;
      if (activeRoute === '/') {
        this.currentRoute = 'root';
      } else if (activeRoute.includes('/datalabs')) {
        this.currentRoute = 'datalabs';
      } else if (activeRoute.includes('/prompt-generator')) {
        this.currentRoute = 'prompt-generator';
      } else if (activeRoute.includes('/translate')) {
        this.currentRoute = 'translate';
      } else if (activeRoute.includes('/chat')) {
        this.currentRoute = 'chat';
      }
      else {
        this.currentRoute = '';
      }
    })
  }

  stopDatalabsProcess() {
    this.chatStateService.datalabsStopProgress.next(true);
    this.toastMessage.showSuccess('Current process stopped!')
    this.uploadProgress = false;
  }


  newChat() {
    if (this.currentRoute == 'datalabs' || this.currentRoute == 'prompt-generator' || this.currentRoute == 'translate') {
      window.location.reload();
      return;
    }


    this.chatStateService.activeFeaturState.next('');
    this.chatStateService.featureState.next('');
    this.chatStateService.datalabsFile.next('');
    this.chatStateService.chatPromptState.next(null);
    this.chatStateService.chatDataAppendState.next('');
    this.chatStateService.chatHistoryDetailState.next(null);
    this.router.navigate(['']);
    this.selectedFiles = [];
    this.clearUserRecord();
    this.gcpFilePaylaod = null;
    this.loaderService.hideProgress();
  }

  startVoiceRecognition() {
    this.voiceService.startListening();
    let stopBlock = document.getElementById('speechStop');
    if (stopBlock) stopBlock.style.display = 'block';

    let startBlock = document.getElementById('speechStart');
    if (startBlock) startBlock.style.display = 'none';
  }

  stopVoiceRecognition() {
    this.voiceService.stopListening();
    let stopBlock = document.getElementById('speechStop');
    if (stopBlock) stopBlock.style.display = 'none';

    let startBlock = document.getElementById('speechStart');
    if (startBlock) startBlock.style.display = 'block';
  }


  autoResize(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;

  }

  autoResize1(): void {
    const textarea = document.getElementById('textArea') as HTMLTextAreaElement;
    textarea.style.height = '35px';
    // textarea.style.height = `${textarea.scrollHeight}px`;

  }

  handleEnter(): void {
    this.prompt = this.prompt.replace(/(\r\n|\n|\r)$/, '');
    //this.handleSubmit();
    this.sentToInput();
  }

  validatePrompt() {
    let myFiles: any = [];
    this.selectedFiles.forEach((file: any) => {
      myFiles.push(file);
    });

    let chatObj: any = {
      role: 'assistant',
      content: myFiles,
      section: 'file_uploaded',
      title: "Uploaded Files",
      timeStamp: new Date()
    }

    if (this.chatConfig?.chat_model == 'gcp') {
      chatObj = { ...chatObj, ...this.gcpFilePaylaod }
    }

    this.chatStateService.chatDataAppendState.next(chatObj);
    this.chatStateService.translateFileUpload.next({ "files": myFiles });

    let value = this.prompt
    this.selectedFiles = [];

    // sumbit prompt
    if (value.trim()) this.sentToInput();

  }

  async sentToInput() {
    if (this.currentRoute == 'datalabs') {
      if (this.selectedFiles.length > 0) {
        console.log(this.selectedFiles);
        const datalabsFile = this.selectedFiles;
        this.chatStateService.datalabsFile.next({ file: datalabsFile });
        this.clearFileInput('upload_chatFile');
      }


      let value = this.prompt
      if (!(value.trim()) && this.selectedFiles.length == 0) {
        this.toastMessage.showError('Question is required');
        return;
      }

      this.selectedFiles = [];
      console.log('do nothing', value)

    } else if (this.currentRoute == 'prompt-generator') {
      this.chatStateService.imagePromptStatus.next(this.promptImageStatus);

    } else if (this.currentRoute == 'translate') {
      if (this.selectedFiles.length > 0) {
        console.log('translate', this.selectedFiles);
        const datalabsFile = this.selectedFiles;
        this.chatStateService.translateFileUpload.next({ file: datalabsFile });
        this.clearFileInput('upload_chatFile');
        // this.selectedFiles = [];
      }
    }
    else {
      if (this.isStreaming() && !this.uploadProgress) return;
      this.chatStateService.chatPromptState.next(null);



      if (this.selectedFiles.length > 0) {
        //await this.uploadUserFile();
        if (this.chatConfig?.chat_model == 'gcp') {
          this.uploadGCPFile();
        } else {
          this.uploaduserFile();
        }


        this.clearFileInput('upload_chatFile');
        if (!this.uploadStatus) return;
      }

      this.uploadStatus = false;
      let value = this.prompt
      if (!(value.trim())) {
        this.toastMessage.showError('Question is required');
        return;
      }


      if (!this.router.url.startsWith('/chat')) {
        this.router.navigate(['/chat']);
      }

    }


    this.chatStateService.chatPromptState.next(this.prompt);

    if (this.currentRoute != 'translate') this.prompt = '';





    this.autoResize1();

  }



  // file upload functionality

  uploadImage() {
    this.clearFileInput('upload_chatFile');
    this.imageUpload = true;
    setTimeout(() => {
      document.getElementById('upload_chatFile')?.click();
    }, 0);
  }


  uploadFile(type = 'upload') {
    this.clearFileInput('upload_chatFile');

    if (type == 'upload') {
      this.imageUpload=false;
      //document.getElementById('upload_chatFile')?.click();
      this.fileInput.nativeElement.value = '';
      this.fileInput.nativeElement.click();
    }

    this.addCancelDetection();
  }

  private addCancelDetection(): void {
    // We'll use a timeout to check if files were selected
    // If after a reasonable time no change event fired, we assume cancellation
    setTimeout(() => {
      if (!this.fileInput.nativeElement.value) {
        // No files were selected (dialog was likely cancelled)
        this.chatStateService.fileuploadSignal(false);
      }
    }, 500); // 500ms should be enough time for the change event to fire if files were selected
  }

  async uploads(event: any) {
    if (this.currentRoute == 'translate') this.selectedFiles = []


    if (event.target.files?.length > 0) {
      let fileSizeMB = 0;
      let maxFileSize = 16;
      this.newFiles = Array.from(event.target.files);


      for (const file of event?.target?.files) {
        // checking file type
        if (!this.checkFileSupported(file)) {
          this.clearFileInput('upload_chatFile');
          this.toastMessage.showError('Invalid file format.');
          this.chatStateService.fileuploadSignal(false);

          return;
        }

        //  clacuation file size
        fileSizeMB = fileSizeMB + (file.size / 1024 ** 2);

        let TranscribeExtentsions = ['.mp3', '.mp4', '.m4a', '.m4v', '.wav'];

        if (event.target.files?.length == 1) {
          let transcribeFile = event.target.files[0]
          let checkTranscribeFile = TranscribeExtentsions.includes(this.checkFileExtension(transcribeFile));
          if (checkTranscribeFile) maxFileSize = 50;
        }

        if (fileSizeMB > maxFileSize) {
          this.clearFileInput('upload_chatFile');
          if (this.currentRoute === 'translate') {
            maxFileSize = 16;
          }
          this.toastMessage.showError(`File size should be less than ${maxFileSize} MB`);

          return;
        }

        let fileExtension = this.checkFileExtension(file).split('.')[1];
        for (let i = 0; i < this.uploadFileCategory.length; i++) {
          this.uploadFileCategory[i].match = this.uploadFileCategory[i].value.includes(fileExtension);
        }

      }


      let myfileName: any = [];
      for (const file of event?.target?.files) {
        myfileName.push(file.name);
      }

      if (myfileName?.length > 1) {
        localStorage.setItem('fileName', 'multi');
      } else {
        localStorage.setItem('fileName', myfileName[0]);
      }

      const newFiles: FileList = event.target.files;
      const newFilesArray = Array.from(newFiles);

      // Append new files to the existing selectedFiles array, avoiding duplicates
      newFilesArray.forEach((file: any) => {
        if (!this.selectedFiles.some((existingFile: any) => existingFile.name === file.name && existingFile.size === file.size)) {
          this.selectedFiles.push(file);
        }
      });
      this.chatStateService.fileuploadSignal(false);

      // Log the selectedFiles array to verify the files are being appended correctly



      if (this.currentRoute != 'translate') this.uploadFile()

    } else {
      this.chatStateService.fileuploadSignal(false);

      // This else block is intentionally left blank as per requirement
    }
  }

  //datalabs validation


  checkFileExtension(file: any) {
    // checking file type
    let patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
    let fileExtension = (file.name).match(patternFileExtension);
    return '.' + fileExtension[1];
  }

  checkFileSupported(file: any) {
    this.chatConfig['chat_model'] = this.chatConfig['chat_model'] ? this.chatConfig['chat_model'] : 'gpt';
    // return this.inputAccept.split(',').includes(this.checkFileExtension(file));
    let accept;
    if (this.currentRoute == 'translate') {
      accept = this.translateinputAccept;
    } else {
      accept = (this.currentRoute !== 'datalabs') ? (this.chatConfig['chat_model'] != 'gcp' ? this.inputAccept : this.inputGcpChatAccept) : this.inputDatalabsAccept;

    }
    // const accept = (this.currentRoute !== 'datalabs') ? (this.chatConfig['chat_model'] != 'gcp' ? this.inputAccept : this.inputGcpChatAccept) : this.inputDatalabsAccept;
    return accept.split(',').includes(this.checkFileExtension(file));//new condition based on route
  }

  clearFileInput(id: string) {
    let input1 = document.getElementById(id) as HTMLInputElement;
    input1.value = '';
    // this.selectedFiles = [];
  }



  resetFileGCP() {
    let data = {
      chat_model: 'gcp',
      file: this.selectedFiles,
      file_status: 'remove'
    }
    this.chatStateService.chatDataAppendState.next(data);
    this.gcpFilePaylaod = null;
  }

  resetFile(index: number) {
    if (arrayHasIndex(this.selectedFiles, index)) {
      if (this.selectedFiles) {
        this.selectedFiles.splice(index, 1);
      }
    }
    if (this.selectedFiles?.length != 0) {
      this.chatStateService.activeFeaturState.next(this.uploadFileCategory);
      this.chatStateService.activeFeatureUplaodFile.next(this.selectedFiles);
    }
    else {

      if (this.currentRoute != 'translate') this.router.navigate(['/']);
      this.chatStateService.activeFeaturState.next('');
      this.chatStateService.activeFeatureUplaodFile.next('');
    }

  }

  // auto call api

  uploaduserFile(): Promise<void> {

    const formData = new FormData();

    // Append each file to the FormData object
    for (const file of this.selectedFiles) {
      formData.append('files', file, file.name);
    }

    this.loaderService.showProgress();
    return new Promise((resolve, reject) => {
      this.oneUIService.uploadUserFile(formData).subscribe(
        (res: any) => {
          if (res?.status === 'success') {
            // Optionally show success message here

            resolve();

            if (res?.message == 'Files Uploaded successfully') {
              this.loaderService.hideProgress();
              this.toastMessage.showSuccess(res?.message);
              this.uploadStatus = true;
              this.validatePrompt();
              return;
            }
            this.startInterval();
          } else {
            reject(new Error(res?.message || 'Upload failed'));
            this.loaderService.hideProgress();
          }
        },
        (error) => {
          console.error(error);
          reject(error);
          // Optionally show error message here
          this.stopInterval();
          this.loaderService.hideProgress();

        }
      );
    });
  }

  uploadGCPFile() {
    this.loaderService.showProgress();

    if (this.selectedFiles?.length > 1) {
      this.toastMessage.showError('Only singal file at a time allowed.');
      return;
    }

    let file = this.selectedFiles[0];

    const formData = new FormData();
    formData.append('file', file, file.name);
    this.chatGptService.uploadChatFile(formData).subscribe((res: any) => {
      if (res?.status == 'success') {
        this.gcpFilePaylaod = {
          response: res,
          chat_model: 'gcp',
          file: file,
          file_status: 'add'
        }

        this.toastMessage.showSuccess(res?.message);
        this.validatePrompt();
      } else {
        this.toastMessage.showError(res?.message);
      }

      this.loaderService.hideProgress();
      this.uploadStatus = true;
    },
      (error) => {
        // Handle error response
        this.toastMessage.showError(error?.error?.message || 'File upload failed. Please try again.');
        this.loaderService.hideProgress();
        this.uploadStatus = false;
      })
  }





  startInterval(): void {
    this.checkFileStatus();
    this.intervalId = setInterval(() => { this.checkFileStatus(); }, 10000);
  }

  stopInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  stopStream() {
    this.chatGptService.stopStreaming();
  }

  isStreaming(): boolean {
    return this.chatGptService.streaming;
  }


  checkFileStatus() {
    this.oneUIService.userFileStatus().subscribe((res: any) => {
      if (res?.status == 'success' && res?.message == 'Files uploaded successfully') {
        // this.checkuserIntension();
        this.stopInterval();
        this.loaderService.hideProgress();
        this.toastMessage.showSuccess(res?.message);
        this.uploadStatus = true;
        this.validatePrompt();
      } else if (res?.status != 'success') {
        this.loaderService.hideProgress();
      }

    }, (error: any) => {
      this.stopInterval();
      console.error(error);
      // this.toastMessage.showError(error?.message);
      this.loaderService.hideProgress();

    })
  }

  clearUserRecord() {
    this.oneUIService.clearUserRecord().subscribe((res: any) => {
      if (res?.status == 'success') {

      }
    })
  }


  checkuserIntension() {

    //need to make gpt config dynmaic 
    let payload = {
      "messages": [
        {
          "role": "user",
          "content": "",
          "timeStamp": new Date()
        }
      ],
      "top_p": 0.95,
      "temperature": 0.5,
      "max_tokens": 2000
    }
    this.oneUIService.chatStreamBot(payload).subscribe((res: any) => {
      if (res?.status == 'success') {
        this.handleIntention(res);
      }
    }, (error: any) => {
      console.error(error);
      // this.toastMessage.showError(error?.message);
    })
  }

  handleIntention(data: any): any {

    let feature = {
      name: ''
    }
    switch (data.intention) {
      case 'image':
        feature.name = 'image';
        break;

      case 'translation':
        feature.name = 'translate';
        break;

      case 'transcription':
        feature.name = 'transcribe';
        break;

      case "document":
        feature.name = 'byod';
        break;

      case "normal":
        feature.name = 'chat';
        break;

      default:
        feature.name = 'chat';
    }


    // this.submitOption(feature);
  }




  changeOptionValue(value: 'azure' | 'google') {
    // Set the dropDownValue to the passed value
    this.dropDownValue = value;

    // Validate the dropDownValue and set default if necessary
    if (this.dropDownValue !== 'azure' && this.dropDownValue !== 'google') {
      this.dropDownValue = 'azure';
    }

    // Store the validated dropDownValue in local storage
    localStorage.setItem('translate_model', this.dropDownValue);

    // Notify the chat state service about the change
    this.chatStateService.chatModelState.next(this.dropDownValue);
    this.chatModelSwitch(value);
  }


  chatModelSwitch(value: any) {

    if (value == 'google') {
      this.chatConfig['chat_model'] = 'gcp'

      this.chatStateService.chatConfigState.next(this.chatConfig);

    } else {
      this.chatConfig['chat_model'] = value

      this.chatStateService.chatConfigState.next(this.chatConfig);

    }
  }


  gptModelSwitchBlock() {
    if ((this.deploymentEnv != 'PROD' || this.currentRoute == 'translate') && (this.currentRoute == 'translate'
      || this.currentRoute == 'chat' || this.currentRoute == 'root')) {
      return true;
    }
    return false;
  }




  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.uploadSub?.unsubscribe();
    this.subSpeech?.unsubscribe();
    this.subLoading?.unsubscribe();
    this.myRouterSub?.unsubscribe();
    this.subChatConfig?.unsubscribe();
  }

}

const arrayHasIndex = (array: any[], index: number): boolean => {
  return Array.isArray(array) && array.hasOwnProperty(index);
};